<template>
  <with-actions>
    <div class="ml-auto" slot="context-actions">
      <router-link class="btn btn-primary" :to="{ name: 'organizations_create' }">New organization</router-link>
    </div>
    <div class="card">
      <table class="table table-hover">
        <thead>
          <tr>
            <th>Name</th>
            <th>Accounting Adapter</th>
          </tr>
        </thead>
        <tbody>
          <router-link
            role="button"
            :key="organization.id"
            :to="{ name: 'organization_edit', params: { organization_id: organization.id } }"
            tag="tr"
            v-for="organization in organizations"
          >
            <td>{{ organization.name }}</td>
            <td>{{ organization.accounting_adapter }}</td>
          </router-link>
        </tbody>
      </table>
    </div>
  </with-actions>
</template>
<script>
import Api from '@/store/jsonapi';

export default {
  data: function () {
    return {
      organizations: []
    };
  },
  watch: {},
  computed: {},
  methods: {},

  mounted: async function () {
    this.setBreadcrumbs([{ to: { name: 'organizations' }, text: 'Organizations' }]);

    let { data } = await Api.findAll('organizations');

    this.organizations = data;
  }
};
</script>
